import { Checkbox, FormControl, IconButton, InputLabel, MenuItem, Select, TableCell, TableRow, TextField } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { customComponentMap, customComponentSettings } from './animalListCustomComponents.js';
import moment from "moment";

function AnimalListItemCreate({ rowData, index, columns, onChange, onDelete, onSelect, isSelected, productId }) {
    const renderInput = (attr, col) => {
        if (['dob', 'dateOfCoverage', 'dobOfMamber'].includes(attr)) {
            return (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        views={['year', 'month', 'day']}
                        inputFormat="dd-MM-yyyy"
                        value={rowData[attr] ? moment(rowData[attr], "DD-MM-YYYY").toDate() : null}
                        onChange={(val) => {
                            const formattedDate = val ? moment(val).format("DD-MM-YYYY") : null;
                            onChange(attr, formattedDate);
                        }}
                        maxDate={new Date()}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                fullWidth
                                style={{ minWidth: "180px" }}
                            />
                        )}
                    />
                </LocalizationProvider>
            );
        }

        if (attr === 'gender') {
            return (
                <FormControl fullWidth size="small" style={{ minWidth: '200px' }}>
                    <InputLabel>Gender</InputLabel>
                    <Select
                        label="Gender"
                        value={rowData[attr] || ''}
                        onChange={(e) => onChange(attr, e.target.value)}
                        style={{ minWidth: '200px' }}
                    >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                    </Select>
                </FormControl>
            );
        }

        const CustomComponent = customComponentMap[attr];
        const CustomSetting = customComponentSettings[attr];
        if (CustomComponent) {
            return (
                <CustomComponent
                    tableListDatas={[rowData]}
                    index={0}
                    productId={productId}
                    label={col.title || col.sumInsuredHeader.title || attr}
                    apiUrl={CustomSetting}
                    handleChange={(attr, _, value) => onChange(attr, value)}
                />
            );
        }

        return (
            <TextField
                size="small"
                fullWidth
                type={['age', 'sumInsured', 'premium'].includes(attr) ? 'number' : 'text'}
                value={rowData[attr] || ''}
                onChange={(e) => onChange(attr, e.target.value)}
            />
        );
    };

    return (
        <TableRow>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onChange={e => onSelect(e.target.checked)} disabled />
            </TableCell>
            <TableCell>{index + 1}</TableCell>
            {columns.map(col => {
                const attr = col.sumInsuredHeader.attribute;
                return <TableCell key={attr}>{renderInput(attr, col)}</TableCell>;
            })}
            <TableCell>
                <IconButton size="small" onClick={onDelete}>
                    <DeleteIcon fontSize="small" color="error" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
}

export default AnimalListItemCreate;